function FarmerDC(){
     return(
           <div>  
             <h2>FarmerDC</h2>
             <p>details here</p>
            </div>
         );
}
export default FarmerDC;